import type { EstadoMovimiento, EstadoDistribucion } from '../types';

type BadgeStyle = { bg: string; text: string; dot: string };

// Tipos locales para los badges de cobros/egresos pendientes (no pertenecen al dominio core)
export type EstadoIngreso = 'Cobrado' | 'Parcial' | 'Sin Cobrar';
export type EstadoEgreso  = 'Pagado'  | 'Pendiente';

export const ESTADO_MOVIMIENTO_STYLES: Record<EstadoMovimiento, BadgeStyle> = {
  Completado: { bg: 'bg-blue-50',  text: 'text-blue-700',  dot: 'bg-blue-600'  },
  Pendiente:  { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' },
  Parcial:    { bg: 'bg-sky-50',   text: 'text-sky-700',   dot: 'bg-sky-400'   },
};

export const ESTADO_INGRESO_STYLES: Record<EstadoIngreso, BadgeStyle> = {
  Cobrado:     { bg: 'bg-blue-50',  text: 'text-blue-700',  dot: 'bg-blue-600'  },
  Parcial:     { bg: 'bg-sky-50',   text: 'text-sky-700',   dot: 'bg-sky-400'   },
  'Sin Cobrar':{ bg: 'bg-gray-100', text: 'text-gray-600',  dot: 'bg-gray-400'  },
};

export const ESTADO_EGRESO_STYLES: Record<EstadoEgreso, BadgeStyle> = {
  Pagado:   { bg: 'bg-blue-50',   text: 'text-blue-700',  dot: 'bg-blue-600'  },
  Pendiente:{ bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' },
};

export const ESTADO_DISTRIBUCION_STYLES: Record<EstadoDistribucion, BadgeStyle> = {
  Liquidado: { bg: 'bg-green-50', text: 'text-green-700', dot: 'bg-green-500' },
  Cancelado: { bg: 'bg-red-50',   text: 'text-red-700',   dot: 'bg-red-500'   },
};
